<template>
  <div class="grade-resultados-produtos">
    <b-row
      v-if="resultados.length > 0"
      class="grade-produtos-row"
    >
      <div
        v-for="(produto, indice) in resultados"
        :key="produto.codigo"
        class="coluna-produto d-flex"
      >
        <product-item
          :tracking-ativo="trackingAtivo"
          :codigo="produto.codigo"
          :multiplo="produto.multiplo"
          :titulo="produto.titulo"
          :tipo_origem_produto="produto.tipo_origem_produto"
          :url_foto="produto.url_foto"
          :cliente_codigo="clienteCodigo"
          :valor_unitario="produto.valor_unitario"
          :estoques="produto.estoques"
          :cd_filial="codigoFilial"
          :valida_estoque="produto.bo_vender_sem_estoque"
          :favorito="produto.favorito"
          :termo-busca="termoBusca"
          :posicao-produto="indice + 1"
          @onAddMga="$emit('adicionarMga', $event)"
          @onAddItj="$emit('adicionarItj', $event)"
          @onAdd="$emit('adicionar')"
          @onHideProduct="$emit('ocultarProduto', $event)"
          @onFavoritado="encaminharFavorito"
        >
          <template v-slot:addButton="propriedadesSlot">
            <slot name="addButton" :data="propriedadesSlot.data"></slot>
          </template>
        </product-item>
      </div>
    </b-row>

    <div v-if="carregando" class="text-center">
      <b-spinner
        variant="secondary"
        class="mt-3"
        label="Buscando produtos..."
      ></b-spinner>
    </div>
  </div>
</template>

<script>
import ProductItem from "../ProductItem";

export default {
  name: "gradeResultadosProdutos",
  components: { ProductItem },
  props: {
    trackingAtivo: {
      type: Boolean,
      default: false,
    },
    resultados: {
      type: Array,
      default: () => [],
    },
    carregando: Boolean,
    clienteCodigo: {
      type: Number,
      default: 0,
    },
    codigoFilial: {
      type: Number,
      default: 0,
    },
    termoBusca: {
      type: String,
      default: "",
    },
  },
  methods: {
    encaminharFavorito(codigoProduto, favorito) {
      this.$emit("favoritar", codigoProduto, favorito);
    },
  },
};
</script>

<style scoped>
.grade-produtos-row {
  gap: 24px;
  margin-right: 0;
  margin-left: 0;
  padding-bottom: 2px;
  overflow: visible;
}

.grade-resultados-produtos ::v-deep .product-item-card {
  margin-bottom: 8px;
}

.coluna-produto {
  overflow: visible;
}

@media (min-width: 1400px) {
  .coluna-produto {
    width: calc((100% - 72px) / 4);
  }
}

@media (min-width: 768px) and (max-width: 1399px) {
  .coluna-produto {
    width: calc((100% - 8px) / 2);
  }
}

@media (max-width: 767px) {
  .coluna-produto {
    min-height: 20rem;
    width: 100%;
  }
}
</style>
